module.exports = __webpack_public_path__ + "img/bringg-logo.eda120fe.svg";